import { createAction } from '@reduxjs/toolkit';
import { alertActions } from '_actions';
import { masterDataService } from '_services';
import { ActionNames, Errors } from '_constants'

export const masterDataActions = {
    load: () => dispatch => {
        dispatch(masterDataActions.loadRequest());
        masterDataService.loadAll()
            .then(
                messages => {
                    dispatch(masterDataActions.loadSuccess(messages));
                },
                error => {
                    dispatch(masterDataActions.loadFailure({error: error}));
                    dispatch(alertActions.error(Errors.MASTER_DATA_LOAD_FAILURE));
                }
            );
    },
    loadRequest: createAction(ActionNames.MASTER_DATA_LOAD_REQUEST),
    loadSuccess: createAction(ActionNames.MASTER_DATA_LOAD_SUCCESS),
    loadFailure: createAction(ActionNames.MASTER_DATA_LOAD_FAILURE),

}
